import React from "react";
import "./Future.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { useHomeSection } from "../../../../context/HomePageContext";
import { getStatsFromSection } from "../../../../services/contentApi";
import { stripRichText } from "../../../../utils/richText";

import icon from "../../../../assets/icons/zap.svg";

const Stat = ({ end, suffix, label }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <div className="stat" ref={ref}>
      <h3>
        {inView && <CountUp end={end} duration={2.5} />}
        {stripRichText(suffix)}
      </h3>
      <RichTextContent content={label} as="p" />
    </div>
  );
};

const Future = () => {
  const { section, loading } = useHomeSection("future");

  if (loading || !section?.fields) return null;

  const fields = section.fields;
  const stats = getStatsFromSection(section);

  return (
    <section className="future">
      <div className="future-content">
        <div className="future-icon">
          <img src={icon} alt="icon" />
        </div>

        {fields.title ? (
          <CmsText
            content={fields.title}
            as="h2"
            className="future-title"
          />
        ) : null}

        {fields.description ? (
          <RichTextContent
            content={fields.description}
            className="future-description"
          />
        ) : null}

        <div className="future-stats">
          {stats.map((stat, i) => (
            <React.Fragment key={i}>
              {i > 0 ? <div className="divider" /> : null}
              <Stat
                end={stat.end}
                suffix={stat.suffix}
                label={stat.label}
              />
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Future;
